import classNames from 'classnames';
import React, {useCallback, useState} from 'react';
import {Placement} from 'react-bootstrap/esm/types';
import {FilterNodeTypeDateMonth} from 'src/js/containers/filtering';
import {
  DynamicFilter,
  FILTER_TYPE_DATE_MONTH,
  Filter,
} from 'src/js/lib/filtering';
import {FilterNode} from 'src/js/model/filters_config';

import lightFilterNodeStyles from './LightFilterNodeStyles.less';
import {FilterConfig, useFormatters} from './LightFormatter';

type Props = {
  config: FilterConfig;
  value: string | null | undefined;
  onChange?: (newValue: string | null) => void;
  // isDefaultValue?: boolean;
  // placement?: Placement;
  // fullWidth?: boolean;
};
export const LightMonthFilter: React.FC<Props> = (props) => {
  const {
    config: _config,
    value,
    onChange,
    // isDefaultValue,
    // placement = 'bottom-start',
    // fullWidth = false,
  } = props;
  const filterType = FILTER_TYPE_DATE_MONTH;
  const {t} = useFormatters();
  const config = {
    ..._config,
    ui: {
      label: t(_config.ui.label),
      placeholder: _config.ui.placeholder ? t(_config.ui.placeholder) : _config.ui.placeholder,
      type: filterType,
    },
  };
  const [isOpened, setIsOpened] = useState(false);
  const toggleOpened = useCallback(() => {
    setIsOpened((v) => !v);
  }, []);
  const DateMonthFilter = DynamicFilter.getFilterClass(filterType);
  const filter = value
    ? new DateMonthFilter({
        type: filterType,
        property: config.name,
        value,
      })
    : undefined;
  const changeFilter = useCallback(
    (newFilter: Filter) => {
      const newValue = newFilter.getValue();
      if (onChange) onChange(newValue);
    },
    [onChange]
  );
  const removeFilter = useCallback(
    (_newFilter: Filter) => {
      if (onChange) onChange(null);
    },
    [onChange]
  );
  const inputRef = useCallback(() => {
    // do nothing
  }, []);
  const setFocus = useCallback(() => 0, []);
  const node = new FilterNode(config);
  return (
    <span
      className={classNames(
        lightFilterNodeStyles.dlFilterNodeContent,
        'dlFilterNode'
      )}
      data-name={config.name}
    >
      <FilterNodeTypeDateMonth
        node={node}
        isOpened={isOpened}
        toggleOpened={toggleOpened}
        changeFilter={changeFilter}
        removeFilter={removeFilter}
        selectedFilter={filter}
        inputRef={inputRef}
        setFocus={setFocus}
      />
    </span>
  );
};
